<button mat-button [routerLink]="['/adminhome']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>home</mat-icon>
  <span>Home</span>
</button>


<button mat-button [routerLink]="['/adminhome/courses']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>book</mat-icon>
  <span>Courses</span>
</button>

<button mat-button [routerLink]="['/adminhome/batches']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>book_online</mat-icon>
  <span>Batches</span>
</button>

<button mat-button [routerLink]="['/adminhome/students']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>people</mat-icon>
  <span>Students</span>
</button>

<button mat-button [routerLink]="['/adminhome/quizes']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>quiz</mat-icon>
  <span>Quizes</span>
</button>


<button mat-button [routerLink]="['/adminhome/manage-videos']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>movie</mat-icon>
  <span>Videos</span>
</button>


<button mat-button [routerLink]="['/adminhome/requests']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>movie</mat-icon>
  <span>Requests</span>
</button>

<button mat-button [routerLink]="['/adminhome/accounts']" [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>group</mat-icon>
  <span>Accounts</span>
</button>

<button mat-button (click)=logout() [routerLink]='' [color]="color"
        (mouseover)="color = 'warn'"
        (mouseout)="color = 'accent'">
  <mat-icon>logout</mat-icon>
  <span>Logout</span>
</button>
